module.exports = __webpack_public_path__ + "static/media/p5.ccbae08a.jpg";